import type { TFunction } from 'i18next';

import type { CoinType } from '../stores/cointype/CoinTypeStore';

import { formatValueWithK } from './helpers';

export function formatAmountByCoinType({
  amount,
  coinType,
  t,
  locale,
}: {
  amount: number;
  coinType: CoinType;
  t: TFunction;
  /** BCP 47 locale for number formatting. Omitted -> the runtime default locale (legacy behaviour). */
  locale?: string;
}): string {
  if (coinType === 'GC') {
    const abbreviated = formatValueWithK(amount, t);
    if (!locale) return abbreviated;
    // formatValueWithK always emits a '.' decimal point; swap in the locale's own decimal separator.
    const decimal = new Intl.NumberFormat(locale).formatToParts(1.1).find((p) => p.type === 'decimal')?.value ?? '.';
    return decimal === '.' ? abbreviated : abbreviated.replace('.', decimal);
  }
  return amount.toLocaleString(locale);
}
